<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">小程序</span>
        <el-autocomplete
          v-model="parameterNames.mini_program"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '小程序'"
          @clear="(parameterNames.mini_program = null),(parameter.mini_program_id = null)"
          @select="handleSelect"
        />
      </div><div class="item">
        <span class="item_title">时间段</span>
        <el-select v-model="hours" multiple placeholder="请选择">
          <el-option
            v-for="item in hourss"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="parameterNames.release_group_id_name = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="parameterNames.pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search()"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportExport"
      >导出报表</el-button>
    </div>
    <div class="content1">
      <div>合计</div>
      <div>
        <div>消耗：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.sum_cost
              ? tableData.total_data.sum_cost
              : 0
          }}
        </div>
      </div>
      <div>
        <div>消耗(昨天)：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.sum_ayer_costv
              ? tableData.total_data.sum_ayer_costv
              : 0
          }}
        </div>
      </div>
      <div>
        <div>首日LTV：</div>
        <div>
          {{ tableData.total_data && tableData.total_data.sum_0d_ltv ? tableData.total_data.sum_0d_ltv : 0 }}
        </div>
      </div>
      <div>
        <div>首日roi：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.sum_0d_roi
              ? tableData.total_data.sum_0d_roi
              : 0
          }}
        </div>
      </div>
      <div>
        <div>首日ltv(昨天)：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.sum_ayer_0d_ltv
              ? tableData.total_data.sum_ayer_0d_ltv
              : 0
          }}
        </div>
      </div>
      <div>
        <div>首日roi(昨天)：</div>
        <div>
          {{
            tableData.total_data && tableData.total_data.sum_ayer_0d_roi
              ? tableData.total_data.sum_ayer_0d_roi
              : 0
          }}
        </div>
      </div>
    </div>
    <el-table v-for="(item, index) in exitTable" :key="index" :data="item" border :show-header="index === 0" :span-method="mergeColumn">
      <el-table-column prop="channel_hour" label="时间段" width="100px" />
      <el-table-column prop="mini_program_name" label="小程序名称" width="170" />
      <el-table-column prop="release_group_name" label="投放组" width="120" />
      <el-table-column prop="pitcher_name" label="投手" width="120" />
      <el-table-column prop="bind_id" label="绑定关系" width="120" />
      <el-table-column prop="cost" label="消耗" width="120" />
      <el-table-column prop="attribution_micro_game_0d_ltv" label="首日LTV" width="120" />
      <el-table-column prop="attribution_micro_game_0d_roi" label="首日roi" width="120" />
      <el-table-column prop="chain_cost" label="消耗环比" width="120" />
      <el-table-column prop="chain_0d_roi" label="ROI环比" width="120" />
      <el-table-column prop="ayer_cost" label="消耗(昨天)" width="120" />
      <el-table-column prop="ayer_attribution_micro_game_0d_ltv" label="首日LTV（昨天)" width="130" />
      <el-table-column prop="ayer_attribution_micro_game_0d_roi" label="首日roi（昨天)" width="120" />
      <el-table-column prop="proportion_cost" label="消耗整体占比" width="120" />
    </el-table>
  </div>
</template>

<script>
import {
  exportHourReport,
  getAPPList,
  getListOfPitchersInTheLaunchGroup,
  getReleaseGroupList,
  hourReportList
} from '@/api/TKreleaseGroup.js'

export default {
  components: {
    /* Details */
  },
  data() {
    return {
      tableData: {},
      exitTable: [],
      loading: false,
      parameter: {
        mini_program_id: null,
        release_group_id: null,
        pitcher_id: null
      },
      parameterNames: {
        mini_program: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null // 投手
      },
      order_by: {}, // 表格数据排序
      current: null,
      date: new Date().toISOString().split('T')[0],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      hourss: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
      hours: ['11', '14', '16', '18', '20', '23']
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    copywechatname(data) {
      console.log('data:', data.ocean_advertiser, data.advertiser)
      if (data.ocean_advertiser.length === 0 && data.advertiser.length === 0) {
        return this.$message('没有可复制的数据')
      }
      const newdata =
        data.advertiser.length === 0 ? data.ocean_advertiser : data.advertiser
      if (newdata.length >= 1) {
        const arr = []
        newdata.map((item) => {
          if (item.agent_name) {
            // const formatStr = `${item.account_name}-${item.account_id}-${item.agent_name}`
            const formatStr = `${item.account_id}`
            arr.push(formatStr)
          } else {
            const idStr = `${item.account_id}`
            arr.push(idStr)
          }
        })
        const str = arr.join(',').trim()
        if (!navigator.clipboard) {
          const dummyInput = document.createElement('textarea')
          dummyInput.value = str
          dummyInput.style.left = '-9999px'
          dummyInput.style.top = '-9999px'
          dummyInput.style.textAlign = 'left'
          dummyInput.style.whiteSpace = 'pre-line'
          document.body.appendChild(dummyInput)
          dummyInput.select()
          document.execCommand('copy')
          document.body.removeChild(dummyInput)
        } else {
          navigator.clipboard.writeText(str)
        }
      }
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await hourReportList({
        ...ob1,
        query_date: this.date,
        hours: this.hours,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null
      })
      this.tableData = data.data
      console.log(this.tableData.list, '123123123123123123')
      this.exitTable = data.data.list
      this.loading = false
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        小程序: 'name',
        投放组: 'release_group_name',
        投手: 'user_name'
      }

      switch (this.current) {
        case '小程序':
          currentFunc = getAPPList
          break
        case '投放组':
          currentFunc = getReleaseGroupList
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroup
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id:
          this.current === '投手' ? this.parameter.release_group_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(
        data.data.list.map((item) => {
          return {
            value: item[obj[this.current]],
            address: item.id
          }
        })
      )
    },

    // 选中哪一项
    handleSelect(item) {
      console.log(item, '----')
      switch (this.current) {
        case '小程序':
          this.parameter.mini_program_id = item
          break
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
      }
    },

    // 搜索
    search(value) {
      // 清空排序
      !value && (this.order_by.field || this.order_by.order)
        ? this.sortOrderChang()
        : null
      const obj = {
        mini_program_id: 'mini_program',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {
      }
      keys.map((key) => {
        if (
          this.parameter[key] &&
          this.parameter[key].value === this.parameterNames[obj[key]]
        ) {
          obj1[key] = this.parameter[key].address
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      value === '导出' || this.getDataList(obj1)
      return obj1
    },
    // 清空排序
    sortOrderChang() {
      this.order_by = {}
      this.$refs.tableRef.clearSort()
    },
    // 重置
    reset() {
      this.parameter = {
        mini_program_id: null,
        release_group_id: null,
        pitcher_id: null,
        hours: [11, 14, 16, 18, 20, 23]
      }
      this.parameterNames = {
        mini_program: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null // 投手
      }
      this.current = null
      this.sortOrderChang()
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportHourReport({
        ...obj,
        query_date: this.date,
        hours: this.hours,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order
        ? cell.order : cell.order === 'ascending'
          ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order
        ? cell.order : cell.prop
      this.search('排序')
    },
    mergeColumn({ row, column, rowIndex, columnIndex }) {
      // 只对 channel_hour 列进行合并
      if (columnIndex === 0) {
        return rowIndex === 0 ? [this.exitTable[0].length, 1] : [0, 0]
      }
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
textarea {
  text-align: left;
  white-space: pre-line;
}

.content {
  .item {
    display: flex;
    align-items: center;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;

  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;

    .item_title {
      margin-right: 10px;
      display: inline-block;
    }

    .item_input {
      width: 200px;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}

.green {
  background: rgb(52, 229, 54);
}

.yellow {
  background: rgb(255, 247, 173);
}

.blue {
  background: rgb(158, 211, 252);
}

.red {
  background: #ffa500;
}

.magRig {
  margin-right: 10px;
}

.magLfte {
  margin-left: 10px;
}

.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}

.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
}

.content1 {
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}

.content1 > div:nth-child(1) {
  margin-right: 7rem;
}

.content1 > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}

.content1 > div > div:nth-child(2) {
  color: rgb(138, 37, 37);
}

.content1 > div > div:nth-child(3) {
  display: flex;
  align-items: flex-end;
  font-weight: bolder;
  margin-left: 10px;
}

.content1 > div > div > div:nth-child(2) {
  font-size: 0.5rem;
  margin-left: 2px;
}

.color2 {
  color: #0ebb0e;
}

.color1 {
  color: #ef0505;
}

/* .el-table ::v-deep.el-table_1_column_14 ::v-deep.sort-caret.descending {
  border-top-color: #1890ff;
} */
</style>
list: [
  [
    0: {},1:{},2:{},total:{}
  ],
  [
    0: {},1:{},2:{},total:{}
  ],
  [
    0: {},1:{},2:{},total:{}
  ]
]
